import * as tslib_1 from "tslib";
import { ApiService } from './api.service';
import { AppService } from "./app.service";
import { SignalRService } from './signalr.service';
import { RequestsType } from "../model/appConfig";
import { User } from "../model/user.model";
import * as Sentry from '@sentry/browser';
var AuthService = /** @class */ (function () {
    function AuthService(apiService, signalRService, appService) {
        this.apiService = apiService;
        this.signalRService = signalRService;
        this.appService = appService;
        this.authenticated = false;
        this.user = (new User()).init();
        this.currentUser = (new User()).init();
        this.prevUser = (new User()).init();
        if (localStorage.getItem("user") && localStorage.getItem("currentuser")) {
            this.user = JSON.parse(localStorage.getItem("user"));
            this.currentUser = JSON.parse(localStorage.getItem("currentuser"));
            this.authenticated = true;
            // Set Sentry user for restored session
            Sentry.setUser({ id: this.currentUser.name, username: this.currentUser.name });
        }
        if (localStorage.getItem("prevuser")) {
            this.prevUser = JSON.parse(localStorage.getItem("prevuser"));
        }
    }
    AuthService.prototype.authenticate = function (name, password) {
        return this.apiService.authenticate(name, password);
    };
    AuthService.prototype.getChildUsers = function (name, password) {
        return this.apiService.getChildUsers(name, password);
    };
    AuthService.prototype.saveAuthData = function (name, password, children, isChildUser, permissions) {
        if (!isChildUser) {
            this.user.name = name;
            this.user.password = password;
            this.user.children = children;
            this.user.active = true;
            if (permissions) {
                this.user.canControlSchedulerSwitch = permissions.canControlSchedulerSwitch;
                this.user.canEditWeeklyScheduler = permissions.canEditWeeklyScheduler;
                this.user.canEditSpecialDates = permissions.canEditSpecialDates;
            }
            localStorage.setItem("user", JSON.stringify(this.user));
            for (var field in this.user) {
                this.currentUser[field] = this.user[field];
            }
            localStorage.setItem("currentuser", JSON.stringify(this.currentUser));
        }
        else {
            this.currentUser.name = name;
            this.currentUser.password = password;
            this.currentUser.isChildUser = true;
            if (permissions) {
                this.currentUser.canControlSchedulerSwitch = permissions.canControlSchedulerSwitch;
                this.currentUser.canEditWeeklyScheduler = permissions.canEditWeeklyScheduler;
                this.currentUser.canEditSpecialDates = permissions.canEditSpecialDates;
            }
            localStorage.setItem("currentuser", JSON.stringify(this.currentUser));
        }
        this.authenticated = true;
        // Set Sentry user after successful login
        Sentry.setUser({ id: this.currentUser.name, username: this.currentUser.name });
    };
    AuthService.prototype.logout = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var config, error_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.prevUser = this.currentUser.isChildUser ? this.user : this.currentUser;
                        localStorage.setItem("prevuser", JSON.stringify(this.prevUser));
                        this.user = (new User()).init();
                        this.currentUser = (new User()).init();
                        localStorage.removeItem("user");
                        localStorage.removeItem("currentuser");
                        this.authenticated = false;
                        // Clear Sentry user on logout
                        Sentry.setUser(null);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.appService.getConfig()];
                    case 2:
                        config = _a.sent();
                        if (config.requestsType === RequestsType.SignalR) {
                            this.signalRService.disconnect();
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        console.error('Failed to get config during logout:', error_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    AuthService.prototype.setCurrentUser = function (user) {
        this.currentUser = user;
        localStorage.setItem("currentuser", JSON.stringify(this.currentUser));
        // Update Sentry user when switching active user
        Sentry.setUser({ id: this.currentUser.name, username: this.currentUser.name });
    };
    return AuthService;
}());
export { AuthService };
